import { render, staticRenderFns } from "./RevenueSharing.vue?vue&type=template&id=eb8f1ada"
import script from "./RevenueSharing.vue?vue&type=script&lang=js"
export * from "./RevenueSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports